import './inquiry.scss';

import API from './../../../servics/api';

const API_URL = '/wp-admin/admin-ajax.php';
class Inquiry {
    constructor(){
       if(document.getElementsByClassName('inquiry--form--submit').length >0 ){
            this.setupEvents();
       }
    }
    
    setupEvents = () =>{
        document.getElementsByClassName('inquiry--form--submit')[0].addEventListener('click', this.onSubmitClicked,false);
    }

    onSubmitClicked = () => {
        let error = false;
        this.resetAllError();

        if(!this.getValue('name').length>0){
            error= true;
            this.setError('name');
        }
        
        if(!this.getValue('phone').length>0){
            error= true;
            this.setError('phone');
        }

        if(!this.getValue('email').length>0){
            error= true;
            this.setError('email');
        }

        if(!this.isChecked('inquiry--form--gdpr')){
            error= true;
            this.setError('agree');
        }

       

        if(error === false){
            this.sendForm();
        }

    }

    sendForm = () => {

        document.getElementsByClassName('inquiry')[0].classList.add('state-sending');

        let dataObj = new URLSearchParams();
        dataObj.append('action', 'send_inquiry');
        dataObj.append('name', this.getValue('name'));
        dataObj.append('phone', this.getValue('phone'));
        dataObj.append('email', this.getValue('email'));
      
        Array.prototype.slice.call(
            document.getElementsByClassName('inquiry--form--interest'), 0 )
                .reduce(function(result, item) {
                    if(item.checked === true){
                        dataObj.append('interests[]', item.value);
                    }
                    return result;
                },
        []).join(',');
           
        API.sendInquiry(dataObj).then((d)=>{
            document.getElementsByClassName('inquiry')[0].classList.remove('state-sending');
            document.getElementsByClassName('inquiry')[0].classList.add('state-sent');
        })
    }

    isChecked = (name) => {
        return document.getElementsByClassName(name)[0].checked;
    }
    getValue = (name) => {
        console.log(name);
        return document.getElementsByClassName('inquiry--form--' + name)[0].value;
    }

    setError = (name) => {
        document.getElementsByClassName('inquiry--form--' + name)[0].classList.add('error');
    }

    resetAllError = () => {
        const list = ['name', 'phone', 'email'];

        list.forEach((item)=>{
            this.resetError(item);
        });
    }

    resetError = (name) => {
        document.getElementsByClassName('inquiry--form--' + name)[0].classList.remove('error');
    }

}
export default Inquiry;


// WEBPACK FOOTER //
// ./src/components/contentblocks/inquiry/Inquiry.js